import { z } from 'zod';
import { TourneyDetailsSchema } from './showTourneyDetailsInbound';
const ShowUpcomingTourneysInboundSchema = z
    .object({
    tourneys: z.array(TourneyDetailsSchema)
})
    .transform(
// add _type
({ ...rest }) => ({
    _type: 'show_upcoming_tourneys',
    ...rest
}));
export const SHOW_UPCOMING_TOURNEYS_PAYLOAD_DEFINITION = {
    zodSchema: ShowUpcomingTourneysInboundSchema
};
